// @flow


type Options = {
  balanceAvailable: number,
  amount: number,
  targetItemCost: number | null,
  souceItemCost: number | null,
  targetItemFreeCount: number,
  sourceItemFreeCount: number,
}

const getIsSourceItemDisabled = ({
  balanceAvailable,
  amount,
  targetItemCost,
  souceItemCost,
  targetItemFreeCount,
  sourceItemFreeCount,
}: Options): string => {
  if (targetItemCost === null || souceItemCost === null) {
    return 'order_request_sales_exchange_complex_cost_undefined'; // 'Цена комплекта не определена'
  }
  if (!amount) {
    return 'order_request_sales_exchange_complex_amount_undefined'; // 'Количество комплектов не определено'
  }

  const necessaryCost = (amount - sourceItemFreeCount) * souceItemCost;
  const availableCost = balanceAvailable + (amount - targetItemFreeCount) * targetItemCost;

  if (availableCost < necessaryCost) {
    return 'order_request_sales_exchange_complex_insufficient'; // 'Недостаточно средств'
  }

  return '';
};

export default getIsSourceItemDisabled;
